export default __webpack_public_path__ + "static/media/loadingWhite.35f6124b.svg";